import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { save, remove, loadTokens, saveToken } from "../actions/sites";
import { alert } from "../actions/alerts";
import SchemaForm from "../components/SchemaForm";
import LoadingButton from "../components/ui/LoadingButton";
import Table from "../components/Table";
import ApiToken from "../components/ApiToken";
import TokenForm from "../components/TokenForm";

@connect((state, props) => {
  const { siteId } = props.match.params;

  return {
    site: state.sites.sites.find(site => site.id === siteId),
    tokens: state.sites.tokens
  };
})
export default class EditSite extends Component {
  static propTypes = {
    site: PropTypes.object
  };

  state = {
    tokenForm: false
  };

  componentDidMount() {
    const { dispatch, site } = this.props;
    dispatch(loadTokens(site));
  }

  canUseMagnets() {
    const {
      site: { plan }
    } = this.props;

    return plan && plan !== "trial" && plan !== "free";
  }

  getSchema() {
    const schema = {
      name: {
        type: "string",
        label: "Name",
        required: true,
        config: { size: 1, max: 1 }
      },
      endpoints: {
        type: "list",
        of: { type: "string" },
        label: "Endpoints",
        config: { size: 1, max: 1 }
      },
      webhooks: {
        type: "list",
        of: { type: "string" },
        label: "Webhooks",
        config: { size: 1, max: 1 }
      }
    };

    if (this.canUseMagnets()) {
      return {
        ...schema,
        magnets: {
          type: "list",
          of: { type: "string" },
          label: "Fridge Magnets",
          config: { size: 1, max: 1 }
        }
      };
    }

    return schema;
  }

  onExport = e => {
    e.preventDefault();
    // todo
  };

  onSubmit = value => {
    const { dispatch, site } = this.props;
    return dispatch(save(value, site.id));
  };

  onDelete = async e => {
    e.preventDefault();
    const { dispatch, site } = this.props;
    await dispatch(remove(site));
    dispatch(alert({ message: "Site deleted successfully", type: "success" }));
  };

  toggleTokenForm = e => {
    e.preventDefault();
    this.setState(prevState => ({ tokenForm: !prevState.tokenForm }));
  };

  onSubmitToken = async value => {
    const { dispatch, site } = this.props;
    await dispatch(saveToken(value, site));
    this.setState({ tokenForm: false });
  };

  render() {
    const schema = this.getSchema();
    const { site, tokens } = this.props;
    const { tokenForm } = this.state;
    const hasSite = site && site.id;

    return (
      <div className="content scroll-container">
        <SchemaForm schema={schema} value={site} onSubmit={this.onSubmit} />
        {hasSite && (
          <div className="site-keys">
            <h3>API Tokens</h3>
            <Table columns={["Name", "Last Active", "Secret", "Actions"]}>
              {tokens.map(token => (
                <ApiToken token={token} key={token.id} />
              ))}
              {tokenForm && (
                <tr>
                  <td>
                    <TokenForm
                      onSave={this.onSubmitToken}
                      onDismiss={this.toggleTokenForm}
                    />
                  </td>
                </tr>
              )}
            </Table>
            {!tokenForm && (
              <button
                type="button"
                className="btn"
                onClick={this.toggleTokenForm}
              >
                New Token
              </button>
            )}
          </div>
        )}
        {hasSite && (
          <div className="danger-zone">
            <h4>Danger Zone</h4>
            <p>
              <strong>Warning:</strong> Deleting this site will permanently
              remove all content associated with this Fridge. Please know what
              you are doing!
            </p>
            <p>
              <LoadingButton type="button" onClick={this.onDelete}>
                Delete
              </LoadingButton>
            </p>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/containers/EditSite.js